export default function plannedWork() {
    const plannedWorkView = document.querySelector('#spv-plannedWorkView');
    const ongoingWorkView = document.querySelector('#spv-ongoingWorkView');
    const ongoingWorkButton = document.querySelector('#spv-ongoingWorkButton');
    const plannedWorkButton = document.querySelector('#spv-plannedWorkButton');
    if (!plannedWorkView || !ongoingWorkView || !ongoingWorkButton || !plannedWorkButton) {
        return;
    }
    plannedWorkView.style.display = 'none';
    function togglePlanned() {
        if (plannedWorkView.style.display === 'none') {
            plannedWorkView.style.display = 'block';
            ongoingWorkView.style.display = 'none';
            plannedWorkButton.classList.remove('spv-button--secondary');
            plannedWorkButton.classList.add('spv-button--primary');
            ongoingWorkButton.classList.remove('spv-button--primary');
            ongoingWorkButton.classList.add('spv-button--secondary');
            plannedWorkButton.ariaPressed = 'true';
            ongoingWorkButton.ariaPressed = 'false';
        }
        else {
            return;
        }
    }
    function toggleOngoing() {
        if (ongoingWorkView.style.display === 'none') {
            ongoingWorkView.style.display = 'block';
            plannedWorkView.style.display = 'none';
            plannedWorkButton.classList.remove('spv-button--primary');
            plannedWorkButton.classList.add('spv-button--secondary');
            ongoingWorkButton.classList.remove('spv-button--secondary');
            ongoingWorkButton.classList.add('spv-button--primary');
            ongoingWorkButton.ariaPressed = 'true';
            plannedWorkButton.ariaPressed = 'false';
        }
        else {
            return;
        }
    }
    ongoingWorkButton.onclick = toggleOngoing;
    plannedWorkButton.onclick = togglePlanned;
}
plannedWork();
//# sourceMappingURL=planned-work.js.map